module.exports = __webpack_public_path__ + "static/media/india_pic2.805ca21a.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/india_pic2.jpg
 ** module id = 454
 ** module chunks = 0
 **/